// Add click event for product items to show modal using jQuery
$(document).on("click", ".product-item", function (e) {
  const currentId = $(e.currentTarget).data("id");  
  if (currentId) {
    $("#" + currentId).css("display", "block");
  }
});
// Add click event to close modal when clicking on modal-opacity
$(document).on("click", ".close-modal", function (e) {
    const currentId = $(e.currentTarget).data("id");
    if (currentId) {
        $("#" + currentId).css("display", "none");
      }
});

function scrollToTop() {
  window.scrollTo({ top: 0, behavior: "smooth" });
}
